import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import termsPDF from "../../../Assets/Documents/conditions.pdf";
import { options } from "../../../Utils/constants";
import BigIMG from "../Assets//login-render3.webp";

const Register = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData(e.target);
    const formData = Object.fromEntries(data.entries());
    const sponsorId = search ? search?.replace("?", "") : null;
    console.log("🚀 ~ handleSubmit ~ sponsorId:", sponsorId);
    let registerApi = "/api/auth/signup/bazaar";

    if (sponsorId) registerApi = `/api/auth/signup/bazaar/${sponsorId}`;

    let error = false;

    if (formData.password !== formData.confirmPassword) {
      toast.error("Password did not match.", {
        toastId: "confirmPassword",
        hideProgressBar: true,
        style: options.dropdownStyle
      });
      error = true;
    }

    if (!error) {
      const response = await axios
        .post(`${process.env.REACT_APP_EDAIN_URL}${registerApi}`, {
          name: formData.name,
          email: formData.email,
          password: formData.password,
          newsletter: false
        })
        .catch((error) => {
          if (error.response) {
            switch (error.response.status) {
              case 422:
                toast.error(error.response.data.validation.body.message, {
                  toastId: "validEmail",
                  hideProgressBar: true,
                  style: options.dropdownStyle
                });
                break;
              case 409:
                toast.error("An user is already registered with this email address", {
                  toastId: "userAlreadyRegistered",
                  hideProgressBar: true,
                  style: options.dropdownStyle
                });
                break;
              default:
                break;
            }
          }
        });

      if (response.status === 200) {
        localStorage.setItem("jwt", response.data.token);
        toast.success("Congratulations! Verify your email and confirm the email address.", {
          hideProgressBar: true,
          style: options.dropdownStyle
        });
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
    }
  };

  return (
    <div className="login d-flex flex-column flex-lg-row align-items-center">
      <div className="left  w-100 h-100 d-flex align-items-center justify-content-center">
        <div className="w-100 d-flex align-items-center justify-content-center gap-3 flex-column">
          <img src={BigIMG} alt="incentive img" className="img-fluid  d-none d-lg-block" />
        </div>
      </div>
      <div className="right px-3 w-100 h-100 d-flex align-items-center justify-content-center">
        <div className="right-inner px-4">
          <h2 className="font-pnsb text-light text-center text-lg-start">Join Us. Be you.</h2>
          <p className="font-pnsb fw-normal font-size-18 text-light text-center text-lg-start">
            In order for your application to be approved, you must be selected <br /> by an existing
            user and assigned to their team. <br /> The more details you include, the better your
            chances to be quickly <br />
            selected in order to register in the platform.
          </p>
          <form onSubmit={handleSubmit} className="form-sign mt-5" autoComplete="off">
            <fieldset className="mb-4">
              <label htmlFor="name">Username</label>
              <input autoComplete="chrome-off" type="text" id="name" name="name" />
            </fieldset>

            <fieldset className="mb-4">
              <label htmlFor="email">Email</label>
              <input autoComplete="chrome-off" type="text" id="email" name="email" />
            </fieldset>
            <fieldset className="mb-4">
              <label htmlFor="password">Password</label>
              <input autoComplete="chrome-off" type="password" id="password" name="password" />
            </fieldset>
            <fieldset className="mb-4">
              <label htmlFor="password">Confirm password</label>
              <input
                autoComplete="chrome-off"
                type="password"
                id="password"
                name="confirmPassword"
              />
            </fieldset>
            <div className="text-center mb-4">
              <p className="mb-0 font-pnsb font-size-18 text-light fw-normal">
                By creating an account, I accept{" "}
                <a
                  className="general-a-join text-light"
                  target="_blank"
                  rel="noreferrer"
                  href={termsPDF}>
                  ZiXXar Terms & Conditions
                </a>
              </p>
            </div>
            <button>
              <span>Sign up</span>
            </button>
          </form>
          <p className="mb-0 mt-4 text-center font-pnsb font-size-20 text-light fw-normal">
            Already have an account? {""}
            <Link className="general-a-join neon-a-join" to="https://shop.zixxar.net">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};
export default Register;
